import React from 'react';
import styled from 'styled-components';
import { can } from '../../../../supplementary_components/userDataDelegate';
import { isCompanyTruckType, isLeaseOrOwnerTruckType } from '../../../../supplementary_components/driverPayoutUtils';
import {
    calculateJoinedPayoutGross,
    calculateTruckPayoutRpm,
    dollarAmountsDiffer,
    followsWeeklyOwnerPayoutFromCompany,
} from '../../../../main_board_components/plannerBoardSettings';


export const Wrapper = styled.div`
    &>div{
        height:6rem;
        display:flex;
        align-items:center;
    }
    .NoData{
        justify-content:center;
        height:6rem;
        &>span{
            font-size:${props => props.$smallerfont ? "1.8rem" : "2rem"};
            font-weight:700;
            color:var(--extra-light-gray);
        }
    }
    .weekPerformance{
        display: grid;
        gap: 0.3rem;
        grid-template-columns: ${props => props.$dual
            ? "30% 1.05fr 18% 0.55fr"
            : "25% 1.3fr 12.5% 0.7fr"};
        &>div{
            &>:first-child{
                font-size:0.9rem;
                color:var(--light-gray);
            }
        }
        &>:first-child{
            &>:nth-child(2){
                font-size:${props => props.$dual
                    ? (props.$smallerfont ? "1.45rem" : "1.6rem")
                    : (props.$smallerfont ? "2.1rem" : "2.3rem")};
                color:var(--gray);
                font-weight:700;
            }
            padding-left:1rem;
        }
        &>:not(:nth-child(1)){
            &>:nth-child(2){
                font-size:${props => props.$dual
                    ? (props.$smallerfont ? "0.9rem" : "0.95rem")
                    : (props.$smallerfont ? "1rem" : "1.1rem")};
                font-weight:700;
                color:var(--gray);
            }
        }
        &>:nth-child(2), &>:nth-child(3){
            margin: auto;
        }
        
        &>:nth-child(4){
            text-align: right;
            padding-right:0.5rem;
        }
        
    }
`;

export const canShowTruckPayoutSplit = (canSeeRates, truckType, driver1, driver2) => {
    if (!canSeeRates) return false;
    if (!followsWeeklyOwnerPayoutFromCompany()) return false;
    const companyWithPercentage = isCompanyTruckType(truckType)
        && (driver1?.paymentType === 'Percentage' || driver2?.paymentType === 'Percentage');
    if (!isLeaseOrOwnerTruckType(truckType) && !companyWithPercentage) return false;
    if (!can('DRIVER_PAYOUTS', 'VIEW')) {
        return false;
    }
    return true;
};

export const WeeklyPerformanceSection = ({
    loadsList,
    payoutLoads,
    truckType,
    driver1,
    driver2,
    smallerFont,
    canSeeRates = true,
}) => {
    const grandTotals = {
        hasData:false,
        totalGross: 0,
        totalMiles: 0,
        approximateMileage: false
    };
    if(loadsList && loadsList.length > 0){
        let loadWitoutMileage = false;
        grandTotals.hasData = true;
        for(const load of loadsList){
            const amount = load.amountForInvoice != null ? Number(load.amountForInvoice) || 0 : 0;
            grandTotals.totalGross += amount;
            if(load.loadStatus !== "Cancelled" && load.mileage === 0){
                loadWitoutMileage = true;
            }
            if(load.percentageOfTheLoad){
                grandTotals.approximateMileage = true;
            }
            if(load.loadStatus === "Cancelled" && amount > 0){
                grandTotals.totalMiles += load.deadhead * (load.percentageOfTheLoad || 1);
            }else{
                grandTotals.totalMiles += amount > 0 ? (load.mileage + load.deadhead) * (load.percentageOfTheLoad || 1) : 0;
            }
            
        }
        if(loadWitoutMileage || grandTotals.totalGross === 0)grandTotals.totalMiles = 0;
    }

    const showPayoutSplit = canShowTruckPayoutSplit(canSeeRates, truckType, driver1, driver2);
    const payoutGross = showPayoutSplit
        ? calculateJoinedPayoutGross(loadsList, payoutLoads)
        : null;
    const showDualGross = showPayoutSplit && dollarAmountsDiffer(grandTotals.totalGross, payoutGross);
    const grossRpm = grandTotals.totalMiles === 0 ? null : grandTotals.totalGross / grandTotals.totalMiles;
    const payoutRpm = showDualGross ? calculateTruckPayoutRpm(loadsList, payoutLoads) : null;
    const showDualRpm = showDualGross
        && grossRpm != null
        && payoutRpm != null
        && dollarAmountsDiffer(grossRpm, payoutRpm);
    const dualLayout = showDualGross || showDualRpm;

    const grossDisplay = !canSeeRates
        ? "-"
        : showDualGross
            ? `$${grandTotals.totalGross} / $${payoutGross}`
            : `$${grandTotals.totalGross}`;
    const rpmDisplay = !canSeeRates
        ? "-"
        : grandTotals.totalMiles === 0
            ? "N/A"
            : showDualRpm
                ? `$${grossRpm.toFixed(2)} / $${payoutRpm.toFixed(2)}`
                : "$" + grossRpm.toFixed(2);
    
    return <Wrapper $smallerfont={smallerFont} $dual={dualLayout}>
        {grandTotals.hasData? 
            <div className="weekPerformance">
                <div><div>{showDualGross ? "Gross / Payout:" : "Gross:"} </div><div>{grossDisplay}</div></div>
                <div><div>Total Mileage: </div><div>{grandTotals.totalMiles === 0 ? "N/A" : `${grandTotals.totalMiles.toFixed(0)} miles`}</div></div>
                <div><div>{showDualRpm ? "RPM / Payout:" : "RPM:"} </div><div>{rpmDisplay}</div></div>
                <div><div>Load Count: </div><div>{loadsList.length}</div></div>
            </div>
                :
            <div className="NoData"><span>NO LOADS</span></div>
        }
    </Wrapper>
}
